import { IContent, IContentDetail } from 'src/interface';

export const ACTIONS = {
    SET_FONT_SIZE: 'SET_FONT_SIZE',
    TOGGLE_FONT_SIZE: 'TOGGLE_FONT_SIZE',
    PUT_CONTENT: 'PUT_CONTENT',
    OPEN_CONTENT: 'OPEN_CONTENT',
    CLOSE_CONTENT: 'CLOSE_CONTENT',
    IS_OPEN_UPDATE: 'IS_OPEN_UPDATE',
    SET_READ_ID: 'SET_READ_ID',
}

export const toggleFontSize = () => ({
    type: ACTIONS.TOGGLE_FONT_SIZE,
});

export const setFontSize = (fontSize: number) => ({
    type: ACTIONS.SET_FONT_SIZE,
    payload: fontSize,
});

export const putContent = (content: IContentDetail | IContent) => ({
    type: ACTIONS.PUT_CONTENT,
    payload: content,
});

export const _openContent = (content: IContent) => ({
    type: ACTIONS.OPEN_CONTENT,
    payload: content,
});

export const closeContent = () => ({
    type: ACTIONS.CLOSE_CONTENT,
});

export const isOpenUpdate = (isOpen: boolean | undefined) => ({
    type: ACTIONS.IS_OPEN_UPDATE,
    payload: isOpen,
});

export const setReadId = (id: number) => ({
    type: ACTIONS.SET_READ_ID,
    payload: id,
});
